<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建项目"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="币种：" prop="coinType">
          <el-select v-model="detail.coinType" placeholder="请选择">
            <el-option
              v-for="(item, i) in filterCoinTypeList"
              :key="i"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分发币种：" prop="distributionCoinType">
          <el-select v-model="detail.distributionCoinType" placeholder="请选择">
            <el-option
              v-for="(item, i) in filterCoinTypeList"
              :key="i"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总量：" prop="totalFinancing">
          <el-input-number
            v-model="detail.totalFinancing"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input-number v-model="detail.price" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="抢购设备：" prop="buyLimit">
          <el-select v-model="detail.buyLimit" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抢购类型" prop="buyLimit">
          <el-select v-model="detail.foundationType" placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="设置用户额度："
          prop="foundationBaseAmount"
          v-if="detail.foundationType == 1"
        >
          <el-input-number
            v-model="detail.foundationBaseAmount"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="起止时间：" required>
          <el-col :span="7">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="detail.startTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="detail.endTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择截止时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="图片：" prop="imageUrl">
          <upload v-model="detail.imageUrl" :data="{ platform: 1 }"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Editor from 'components/editor'
import Upload from 'components/upload'
import LANGUAGE from 'common/languages'

export default {
  name: 'foundationCreate',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'))
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'))
      callback()
    }
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'))
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'))
      callback()
    }
    return {
      dialogVisible: false,
      detail: {
        distributionCoinType: '',
        foundationType: '',
        buyLimit: '',
      },
      options: [
        {
          value: '0',
          label: 'PC和APP',
        },
        {
          value: '1',
          label: 'PC',
        },
        {
          value: '2',
          label: 'APP',
        },
      ],
      types: [
        { value: '0', label: '普通抢购项目' },
        { value: '1', label: '新人专场' },
      ],
      rules: {
        coinType: {
          required: true,
          message: '请填写',
        },
        price: {
          required: true,
          message: '请填写',
        },
        totalFinancing: {
          required: true,
          message: '请填写',
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change',
          },
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change',
          },
        ],
        distributionCoinType: {
          required: true,
          message: '请填写',
        },
        imageUrl: {
          required: true,
          message: '请填写',
        },
      },
    }
  },
  components: {
    Editor,
    Upload,
  },
  computed: {
    ...mapState('foundationProject', ['coinTypeList', 'languageList']),
    filterCoinTypeList() {
      return this.coinTypeList.map((item) => item.split('_')[0])
    },
  },
  methods: {
    ...mapActions('foundationProject', ['create']),
    closeDialog() {
      this.dialogVisible = false
      this.detail = {}
      this.$refs['form'].resetFields()
    },
    handleSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.doSave()
        }
      })
    },
    doSave() {
      this.create(this.detail).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success',
        })
        this.dialogVisible = false
        this.$emit('refresh', {
          page: 1,
        })
      })
    },
  },
}
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
